import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMultiGuard from 'vue-router-multiguard';
import Multiguard from 'vue-router-multiguard';
import firebase from 'firebase'
import { Message, Loading } from 'element-ui'

Vue.use(VueRouter)

let routes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "guest-page" */'../layouts/guest-page'),

        children: [
          
            {
                path: '/',
                alias: '/login',
                component: () => import(/* webpackChunkName: "auth.login" */'../views/auth/login')
            },

        ]
    },

    {
        path: '/',
        component: () => import(/* webpackChunkName: "default2-page-bp" */'../layouts/default2-page-bp'),
        children: [

            {
                meta: { requiresAuth: true },
                path: '/bp/summary/concours',
                component: () => import(/* webpackChunkName: "bp.summary" */'../views/bp/summary'),
                beforeEnter: Multiguard([isLoggedAsParticipant, soummettreProjet]),
                name: 'summary-concours',
                beforeEnter: VueMultiGuard([isLoggedAsParticipant]),
                beforeRouteLeave: VueMultiGuard([accessSummary])

            },
            {
                path: '/bp/summary',
                meta: { requiresAuth: true },
                component: () => import(/* webpackChunkName: "bp.summary" */'../views/bp/summary'),
                name: 'summary',
                beforeEnter: VueMultiGuard([quotaProjets, accessSummary])
            },
            {
                meta: { requiresAuth: true },
                path: '/bp/summary/:id',
                component: () => import(/* webpackChunkName: "bp.singleSummary" */'../views/bp/summary'),
                name: 'singleSummary',
                beforeEnter: VueMultiGuard([accessSummary])
            },
            {
                path: "/bp/summary/:id/print",
                component: () => import(/* webpackChunkName: "bp.exportSummary" */"../views/bp/exportSummary"),
                props: true
            },
            {
                meta: { requiresAuth: true, windowRedirectAfter: true },
                path: '/bp/projets',
                component: () => import(/* webpackChunkName: "bp.selection-projet" */'../views/bp/selection-projet'),
                name: "projets",
                beforeEnter: VueMultiGuard([isLoggedAsParticipant])
            },
               {
                meta: { requiresAuth: true },
                path: '/bp/summary/soumission/projets',
                component: () => import(/* webpackChunkName: "admin.concours.soumissionProjet" */'../views/admin/concours/soumissionProjet'),
                name: 'soumission-projet-debug',
                beforeEnter: VueMultiGuard([isLoggedAsParticipant])

            },
            {
                meta: { requiresAuth: true },
                path: '/bp/soumission/projets',
                component: () => import(/* webpackChunkName: "admin.concours.soumissionProjet" */'../views/admin/concours/soumissionProjet'),
                name: 'soumission-projet',
                beforeEnter: VueMultiGuard([isLoggedAsParticipant])

            },
          

        ]
        
    },
];
const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active'
})

/* ===================== AUTH GUARD ===================== */
function isLoggedAsParticipant(to, from, next) {
    Loading.service({ fullscreen: true });
    if (to.meta.requiresAuth) {
        let userInfo = localStorage.getItem("userSession");
        
        // Check if userSession is available
        if (userInfo) {
            try {
                userInfo = JSON.parse(userInfo);
                
                // Check if userInfo and userInfo.profile exist
                if (userInfo && (userInfo.profile == '3' || userInfo.profile == '4')) {
                    return next();
                } else {
                    Message.warning({
                        dangerouslyUseHTMLString: true,
                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                    });
                }
            } catch (e) {
                console.error("Failed to parse userSession from localStorage:", e);
                // Handle parsing error if needed
                Message.warning({
                    dangerouslyUseHTMLString: true,
                    message: '<strong>Erreur de session utilisateur, veuillez vous reconnecter</strong>',
                });
            }
        } else {
            Message.warning({
                dangerouslyUseHTMLString: true,
                message: '<strong>Session utilisateur introuvable, veuillez vous connecter</strong>',
            });
        }
    }
}

function soummettreProjet(to, from, next) {
    if (to.meta.requiresAuth) {
        let perm = JSON.parse(localStorage.getItem("userSession"))
        if (perm.permissions.executiveSummary.state && perm.etatConcours) {

          return  next()
        }
        else {
            // console.log('Bad')
            Message.warning({
                dangerouslyUseHTMLString: true,
                message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
            })
        }
    }
}
router.beforeEach((to, from, next) => {
    Loading.service({ fullscreen: true });
    let matchedObject = from.matched.slice().reverse().find(r => r.meta && r.meta.hasOwnProperty('windowRedirectAfter'));
    // $loading({fullscreen:true})
    //  let loadingInstance=Loading.service({ fullscreen: true });
    if (matchedObject) {
        if (matchedObject.meta.windowRedirectAfter === true) {
            window.location.href = to.fullPath;
            return;
        }
    }
    if (to.meta.requiresAuth) {
        firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
            let obj = doc.data();
            let currentuser = firebase.auth().currentUser
            // console.log('Displayname',currentuser.displayName)
            obj.displayName = currentuser.displayName
            // console.log('Objet',obj)
            to.params.user = obj
            to.params.displayName = currentuser.displayName
            return next()
        })
    } else {
        return next()
    }

});


function accessSummary(to, from, next) {
    firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
        let obj = doc.data();
        // console.log('Log user',obj)
        if (obj.adminId && !obj.idConcours) {
            Loading.service({ fullscreen: true });
            if (obj.roleId) {
                obj.roleId.get().then(roleUser => {
                    let perm = roleUser.data().permissions;
                    if (perm.executiveSummary.state) {
                        to.params.data = perm
                        return next()

                    }
                    else {
                        // console.log('route courante',this.$route.path)
                        Message.warning({
                            dangerouslyUseHTMLString: true,
                            message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                        })
                    }


                })
            }
        }

        if (!obj.adminId || obj.idConcours) {
            Loading.service({ fullscreen: true });
            firebase.firestore().collection('permissions').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
                let obj = doc.data()
                let perm = doc.data();
                if (perm.executiveSummary.state) {
                    to.params.data = perm
                   return  next()

                }
                else {
                    // next({path:from.path})
                    // console.log('route courante',this.$route.path)
                    Message.warning({
                        dangerouslyUseHTMLString: true,
                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                    })
                }

            })
        }

    })


}
function quotaProjets(to, from, next) {
    if (to.meta.requiresAuth) {
        let quotaProjets = JSON.parse(localStorage.getItem("userSession")).permissions.quotaProjets
        firebase.firestore().collection('summary').where('user', '==', JSON.parse(localStorage.getItem("userSession")).uid).get().then((querySnapshot) => {

            //    let count=Object.keys(querySnapshot).length
            let count = 0
            querySnapshot.forEach(() => {
                //    console.log('data',doc.data())
                count++
            }
            )
            if (quotaProjets == count) {
                // next()
                // this.$notify.error({
                //     title: 'Error',
                //     message: 'Erreur'
                //     });
                // next(false)
                Message({
                    dangerouslyUseHTMLString: true,
                    message: '<strong>Vous avez atteint votre quota de création de projets</strong>',
                })
                //    console.log('Nombre de projets',count)

            }
            else {
                let userSession = JSON.parse(localStorage.getItem('userSession'));
                userSession.projet = '';
                userSession.projettitre = '';
                //Admin perm
                localStorage.setItem('userSession', JSON.stringify(userSession));
              return  next()

            }

        })

    }
}


/* ===================== PERMISSIONS ===================== */


export default router
